import { useEffect, useState } from 'react';
import { getVastTagPartnerMappings } from '../../api/vastTagPartnerMappings';

let cachedPartnerMappings = null;
let partnerMappingsRequest = null;

const fetchPartnerMappings = async () => {
	if (cachedPartnerMappings) return cachedPartnerMappings;

	if (!partnerMappingsRequest) {
		partnerMappingsRequest = (async () => {
			try {
				const response = await getVastTagPartnerMappings();
				cachedPartnerMappings = response.data.data.partnerMappings;
				return cachedPartnerMappings;
			} catch (error) {
				partnerMappingsRequest = null;
				throw error;
			}
		})();
	}

	return await partnerMappingsRequest;
};

const useVastTagPartnerMappings = () => {
	const [partnerMappings, setPartnerMappings] = useState(cachedPartnerMappings);

	useEffect(() => {
		let isMounted = true;

		const loadPartnerMappings = async () => {
			try {
				const mappings = await fetchPartnerMappings();
				if (isMounted) setPartnerMappings(mappings);
			} catch (error) {
				if (isMounted) setPartnerMappings([]);
			}
		};

		loadPartnerMappings();

		return () => {
			isMounted = false;
		};
	}, []);

	return partnerMappings;
};

export default useVastTagPartnerMappings;
